import $ from 'jquery'

export default function loadRelatedContent(x) {
  var latestFeed = 'https://www.texastribune.org/api/stories/?format=json&limit=4&tag=subject-2016-elections';

  $.ajax({
    url: latestFeed,
    type: 'GET',
    async: true,
    tryCount : 0,
    retryLimit : 3,
    success: latestList,
    error : function() {
        this.tryCount++;
        if (this.tryCount <= this.retryLimit) {
            //try again
            $.ajax(this);
            return;
        }
        return;
    }
  });
}

function latestList(x) {
  $.each(x.results, function () {
    var storyblock = $(
       '<div class="latest-box">' +
         '<div class="related-img-container">' +
           '<img class="lead-img" src="' + $(this)[0].lead_art.thumbnails.letterbox + '"> ' +
         '</div>' +
         '<div class="story-container">' +
           '<h3 class="latest-headline">' +
             '<a href="'+ $(this)[0].url +'?utm_source=sports_latest" class="latest-link">'+
             $(this)[0].headline + '</a></h3>' +
         '</div>' +
         '<p class="series-dateline latest-dateline">' + $(this)[0].readable_pub_date + '</p>' +
         // '<div class="related-prose">' +
         // $(this)[0].summary_caption +
         // '</div>' +
       '</div>'
     );
    $('#js-story-box').append(storyblock);
  });
}

loadRelatedContent();



/** WEBPACK FOOTER **
 ** ./utils/related_content.js
 **/